import { Typography } from "@packages/ds";
import styled from "styled-components";

import DSTag from "ds/Tag";
import * as Toast from "ds/Toast";
import { semiBoldAlias } from "Libs/theme";

export const ToastViewport = styled(Toast.Viewport)`
  position: fixed;
  left: 40px;
  padding: 0;
  margin: 0;
  gap: 8px;
  display: flex;
  flex-direction: column;
  z-index: 1001;
`;

export const ListItem = styled.div`
  display: flex;
  padding: 14px 0;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  padding: 32px;
`;

export const Icon = styled.div`
  flex: 0;
  margin-right: 5px;
`;
export const IconWrapper = styled.div`
  width: 22px;
  height: 22px;
  margin-right: 4px;
  & > svg {
    width: 100%;
    height: 100%;
  }
`;

export const Details = styled.div`
  border-radius: var(--s-8);
  height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 32px 32px 0px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 24px 18px 24px;
`;

export const ProjectNameContainer = styled.div`
  width: 320px;
  max-height: 48px;
`;
export const ProjectName = styled(Typography.Title)`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--mode-text-neutral-default);
`;

export const Region = styled.div`
  color: var(--color-platform-grey-800);
  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
`;

export const RegionContent = styled.div`
  display: flex;
  align-items: start;
  flex-direction: row;
  height: 50px;
  margin-left: 10px;
`;
export const RegionTitle = styled.div`
  display: flex;
  align-items: start;
  color: var(--mode-text-neutral-default-weak);
`;
export const RegionColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
export const RegionSuffix = styled.div`
  margin-left: 5px;
  font-size: 12px;
  ${semiBoldAlias()};
  color: var(--mode-text-neutral-weakest);
`;

export const RegionCarbonIntensity = styled.div`
  color: var(--mode-text-neutral-default-weak);

  font-family: "Open Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  align-self: start;
`;

export const NoAccessTag = styled(DSTag)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 0px;
  margin-right: 12px;
`;

export const CardWrapper = styled.div`
  min-width: 410px;
`;
